<app-collapsible-section heading="Wave Excellence Lever Configuration" [count]="dataSource.data.length">
  @if (defaults.isMersyAdminBranchExcellenceUser) {
    <div section-actions class="OrangeButton section-buttons">
      @if (!isRemoveLeverAssignmentEnabled) {
        <button mat-raised-button (click)="openAssignExcellenceLeverWave()"
          title="Assign Excellence Lever to a Wave" class="btn btn-sm button-color-fix">
          Add Lever <mat-icon class="add-button icon-color-fix">add_box</mat-icon>
        </button>
        <button mat-raised-button (click)="openImportExcellenceLevers()"
          title="Import Excellence Levers from a Wave" class="btn btn-sm button-color-fix">
          Import Levers <mat-icon class="add-button icon-color-fix">content_copy</mat-icon>
        </button>
        <button mat-raised-button (click)="enableRemoveAssignmentMode()"
          title="Unassign levers from this wave" class="btn btn-sm button-color-fix">
          Unassign <mat-icon class="add-button icon-color-fix">remove_circle</mat-icon>
        </button>
      } @else {
        <button mat-raised-button (click)="enableRemoveAssignmentMode()"
          title="Close unassignment mode" class="btn btn-sm button-color-fix">
          Close <mat-icon class="add-button icon-color-fix">close</mat-icon>
        </button>
      }
    </div>
  }

  <div class="admin-table-scroll mat-elevation-z8">
    <table mat-table #itemsList
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="mat-table-custom assignment-table">

      <ng-container matColumnDef="Checkbox">
        <th mat-header-cell *matHeaderCellDef>
          @if (isRemoveLeverAssignmentEnabled) {
            <mat-checkbox class="select-all-checkbox"
              matTooltip="Select All"
              (click)="$event.stopPropagation();"
              (keydown)="$event.stopPropagation();"
              [checked]="isAllSelected()"
              [indeterminate]="isPartiallySelected()"
              (change)="controlAssignedItem($event.checked)">
              Select All
            </mat-checkbox>
          }
        </th>
        <td mat-cell *matCellDef="let element">
          @if (isRemoveLeverAssignmentEnabled) {
            <mat-checkbox (click)="$event.stopPropagation();" (keydown)="$event.stopPropagation();"
              [checked]="removeExcellenceLeverList.includes(element.ExcellenceLeverId)"
              (change)="controlAssignedItem($event.checked, element)">
            </mat-checkbox>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="ExcellenceLever">
        <th mat-header-cell *matHeaderCellDef> Excellence Lever </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.ExcellenceLeverName"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="ChangeLog">
        <th mat-header-cell *matHeaderCellDef>Change Log</th>
        <td mat-cell *matCellDef="let element">
          <compact-history-button
            [item]="element"
            tooltip="View Change Log"
            buttonText="Get History"
            (historyClick)="onHistoryDetail($event, 'WaveExcellenceLeverConfiguration')">
          </compact-history-button>
        </td>
      </ng-container>

      <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"
        class="item">
      </tr>
    </table>
  </div>

  @if (isRemoveLeverAssignmentEnabled && defaults.isMersyAdminBranchExcellenceUser) {
    <div class="stickybottompanel">
      @if (removeExcellenceLeverList.length > 0) {
        <div class="col-lg-6" style="width:50%">
          Total selected Levers : {{removeExcellenceLeverList.length}}
        </div>
        <button class="btn btn-realease btn-sm pull-right button-margin" (click)="confirmRemoveExcellenceLevers()">
          Confirm
        </button>
      } @else {
        <div class="col-lg-6" style="width:50%">
          Please select at least one Lever
        </div>
      }
    </div>
  }
</app-collapsible-section>
